export default __webpack_public_path__ + "static/media/katzeProfile.f71dda63.png";